{
  "name": "quack-of-doom",
  "version": "1.2.2",
  "private": true,
  "type": "module",
  "description": "FPS 3D rétro con paperelle di gomma ostili e cooperativa online.",
  "scripts": {
    "dev": "concurrently -k -n GAME,SERVER -c yellow,cyan \"vite\" \"tsx watch server/index.ts\"",
    "build": "tsc --noEmit && vite build",
    "start": "NODE_ENV=production tsx server/index.ts",
    "test": "tsx --test tests/*.test.ts",
    "test:multiplayer": "node tests/multiplayer.integration.mjs"
  },
  "dependencies": {
    "express": "^5.2.1",
    "three": "^0.185.1",
    "ws": "^8.21.2"
  },
  "devDependencies": {
    "@types/express": "^5.0.6",
    "@types/node": "^26.1.2",
    "@types/three": "^0.185.4",
    "@types/ws": "^8.18.1",
    "concurrently": "^10.0.4",
    "tsx": "^4.23.9",
    "typescript": "^7.0.2",
    "vite": "^8.2.0"
  }
}
